import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-header-logo-home",
  templateUrl: "./header-logo-home.component.html",
  styleUrls: ["./header-logo-home.component.scss"],
})
export class HeaderLogoHomeComponent implements OnInit {
  scrolled: boolean = false;

  ngOnInit() {}
}
